import { render, staticRenderFns } from "./ColumnProductCodePopover.vue?vue&type=template&id=e703e7e6&scoped=true"
import script from "./ColumnProductCodePopover.vue?vue&type=script&lang=js"
export * from "./ColumnProductCodePopover.vue?vue&type=script&lang=js"
import style0 from "./ColumnProductCodePopover.vue?vue&type=style&index=0&id=e703e7e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e703e7e6",
  null
  
)

export default component.exports